export const CONSTANTS = {
  rcaPriceShow: 'rca_price_shown',
  rcaEventOrder: 'rca_comanda_asigurarea',
  rcaEventVehicle: 'rca_step1',
  rcaEventDriver: 'rca_step2',
  rcaEventConfirmationPickUp: 'rca_step3_pickup',
  rcaEventConfirmationDelivery: 'rca_step3_delivery',
  greenCardPriceShow: 'cv_price_shown',
  greenCardEventOrder: 'cv_comanda_asigurarea',
  greenCardEventOrderWithRoadTax: 'cv_comanda_asigurarea_rovinieta',
  greenCardEventVehicle: 'cv_step1',
  greenCardEventDriver: 'cv_step2',
  greenCardEventConfirmationPickUp: 'cv_step3_pickup',
  greenCardEventConfirmationDelivery: 'cv_step3_delivery',
  cascoPriceShow: 'casco_form_shown',
  cascoQuoteRequest: 'casco_quote_request'
};

export const formRules = {
	required: v => !!v || 'Este necesar un raspuns',
	validNumber: v => (!isNaN(parseFloat(v)) && isFinite(v)) || 'Pot fi introduse doar cifre',
	validEmail: v => /.+@.+\..+/.test(v) || 'Adresa e-mail nu este validă',
	// validNewMatriculationNr: v => (v && v.length === 9) || 'N° certificatului de inmatriculare nu este valid',
	// validIdnp: v => (v && v.length === 13) || 'Codul peronal (IDNP) nu este valid',
	// validIdno: v => (v && v.length === 12) || 'Codul fiscal (IDNO) nu este valid',
	// validBodyNr: v => (v && v.length === 17) || 'N° caroseriei nu este valid',
	// validCarPlate: v => v && v.replace(/\s/g, "").length >= 4 && v.replace(/\s/g, "").length <=7 || 'N° de inmatriculare nu este valid',
	// validTempMatriculationNr: v => /^[A-Za-z]\d{9}$/.test(v) || 'N° certificatului de inmatriculare nu este valid',
	// validYear: v => (!isNaN(parseFloat(v)) && isFinite(v) && parseFloat(v) > 1900 && parseFloat(v) < 2030) || 'Anul nu este valid',
	// validPhone: v => {
	// 	const phonePattern = /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{2,6}$/im; // (123)456-7890, 1234567890, +31636363634...
	// 	const digits = v ? v.replace(/\s/g, '') : '';
	// 	return phonePattern.test(digits) || v === '' || v === undefined || 'Numarul de telefon nu este valid';
	// }
};

const DURATIONS_LIST = [
  {
    id: 1,
    text: '15 zile',
    value: 0.1
  },
  {
    id: 2,
    text: '1 luna',
    value: 0.2
  },
  {
    id: 3,
    text: '2 luni',
    value: 0.3
  },
  {
    id: 4,
    text: '3 luni',
    value: 0.4
  },
  {
    id: 5,
    text: '4 luni',
    value: 0.5
  },
  {
    id: 6,
    text: '5 luni',
    value: 0.6
  },
  {
    id: 7,
    text: '6 luni',
    value: 0.7
  },
  {
    id: 8,
    text: '7 luni',
    value: 0.8
  },
  {
    id: 9,
    text: '8 luni',
    value: 0.85
  },
  {
    id: 10,
    text: '9 luni',
    value: 0.9
  },
  {
    id: 11,
    text: '10 luni',
    value: 1
  },
  {
    id: 12,
    text: '11 luni',
    value: 1
  },
  {
    id: 13,
    text: '1 an',
    value: 1
  }
];

export const sections = {
	rca: {
		calculator: {
			value: 1,
			title: 'Calculeaza',
			questions: [
				{
					id: 1,
					order: 1,
					text: 'Autovehicolul este inmatriculat in:',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [3, 9],
					options: [
						{
							id: 1,
							text: 'RM',
							value: 1
						},
						{
							id: 2,
							text: 'Peste Hotare',
							value: 3
						}
					]
				},
				{
					id: 2,
					order: 2,
					text: 'Posesorul autovehicolului este persoana:',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [
						8, 7, 6
					],
					options: [
						{
							id: 1,
							text: 'Fizica',
							value: 0.9
						},
						{
							id: 2,
							text: 'Juridica',
							value: 1.5
						}
					]
				},
				{
					id: 3,
					order: 3,
					text: 'Domiciliu:',
					type: 'radio',
					optionsDirection: 'column',
					parent: 1,
					visibleIf: {
						questionId: 1,
						answer: 1
					},
					children: [],
					options: [
						{
							id: 1,
							text: 'Mun.le Chisinau, Orhei, Hincesti, si Straseni',
							value: 1.4
						},
						{
							id: 2,
							text: 'Raioanele Ialoveni, Anenii Noi, Criuleni',
							value: 1.4
						},
						{
							id: 3,
							text: 'Alte localitati',
							value: 1
						}
					]
				},
				{
					id: 9,
					order: 3,
					text: 'Valabilitatea poliţei:',
					type: 'dropdown',
					parent: 1,
					visibleIf: {
						questionId: 1,
						answer: 2
					},
					children: [],
					options: DURATIONS_LIST
				},
				{
					id: 4,
					order: 4,
					text: 'Tipul autovehicolului:',
					type: 'dropdown',
					parent: null,
					children: [5],
					options: [
						{
							id: 1,
							text: 'Autoturism'
						},
						{
							id: 2,
							text: 'Camion'
						},
						{
							id: 3,
							text: 'Autobuz/Microbuz'
						},
						{
							id: 4,
							text: 'Motocicleta'
						},
						{
							id: 5,
							text: 'Tractor rutier'
						}
					]
				},
				{
					id: 5,
					order: 5,
					text: 'Masa maxima autorizata:',
					type: 'dropdown',
					parent: 4,
					children: [],
					filterable: true,
					filterableText: [
						{
							parentId: 1,
							text: 'Capacitatea cilindrica:'
						},
						{
							parentId: 2,
							text: 'Masa maxima autorizata:'
						},
						{
							parentId: 3,
							text: 'Numarul de locuri:'
						},
						{
							parentId: 4,
							text: 'Capacitatea cilindrica:'
						},
						{
							parentId: 5,
							text: 'Puterea motorului:'
						}
					],
					options: [
						{
							id: 1,
							parentId: 1,
							text: 'Până la 1200 cm³',
							value: 0.7
						},
						{
							id: 2,
							parentId: 1,
							text: 'Intre 1201 si 1600 cm³',
							value: 1
						},
						{
							id: 3,
							parentId: 1,
							text: 'Intre 1601 si 2000 cm³',
							value: 1.1
						},
						{
							id: 4,
							parentId: 1,
							text: 'Intre 2001 si 2400 cm³',
							value: 1.2
						},
						{
							id: 5,
							parentId: 1,
							text: 'Intre 2401 si 3000 cm³',
							value: 1.5
						},
						{
							id: 6,
							parentId: 1,
							text: 'Peste 3000 cm³',
							value: 3
						},
						{
							id: 7,
							parentId: 1,
							text: 'Electromobil',
							value: 0.9
						},
						{
							id: 19,
							parentId: 1,
							text: 'Taxi',
							value: 2,
							visibleIf: {
								questionId: 2,
								answer: 2
							},
						},
						{
							id: 8,
							parentId: 2,
							text: 'Până la 3500 kg',
							value: 1.5
						},
						{
							id: 9,
							parentId: 2,
							text: 'Intre 3501 si 12000 kg',
							value: 1.9
						},
						{
							id: 10,
							parentId: 2,
							text: 'Peste 12000 kg',
							value: 2.3
						},
						{
							id: 11,
							parentId: 3,
							text: 'Microbuz: 9 - 17 pers. inclusiv conducătorul',
							value: 1.5
						},
						{
							id: 12,
							parentId: 3,
							text: 'Microbuz: 18 - 30 pers. inclusiv conducătorul',
							value: 2
						},
						{
							id: 13,
							parentId: 3,
							text: 'Autobuz: mai mult de 30 pers. inclusiv conducătorul',
							value: 2.2
						},
						{
							id: 19,
							parentId: 3,
							text: 'Troleibuze',
							value: 2.2
						},
						{
							id: 14,
							parentId: 4,
							text: 'Până la 300 cm³',
							value: 0.3
						},
						{
							id: 15,
							parentId: 4,
							text: 'Peste 300 cm³',
							value: 0.5
						},
						{
							id: 16,
							parentId: 5,
							text: 'Până la 45 CP, inclusiv',
							value: 0.5
						},
						{
							id: 17,
							parentId: 5,
							text: 'De la 46 CP până la 100 CP, inclusiv',
							value: 0.7
						},
						{
							id: 18,
							parentId: 5,
							text: 'Peste 100 CP',
							value: 0.9
						}
					]
				},
				{
					id: 6,
					order: 6,
					text: 'Numarul persoanelor admise la conducere:',
					type: 'radio',
					optionsDirection: 'row',
					parent: 2,
					children: [8, 7],
          hidden: true,
					visibleIf: {
						questionId: 2,
						answer: 1
					},
					options: [
						{
							id: 1,
							text: 'Limitat',
							value: 1
						},
						{
							id: 2,
							text: 'Nelimitat',
							value: 1.2
						}
					]
				},
				{
					id: 7,
					order: 7,
					text: 'Stagiul persoanelor admise la conducere:',
					type: 'dropdown',
					parent: 6,
					filterableText: [
						{
							parentId: 1,
							text: 'Stagiul persoanelor admise la conducere:'
						},
						{
							parentId: 2,
							text: 'Stagiul de conducere a posesorului:'
						}
					],
					children: [],
					options: [
						{
							id: 1,
							text: 'Pana la 1 an',
							sumValue: 0.1,
							years: 0
						},
						{
							id: 2,
							text: '1 an',
							sumValue: 0.1,
							years: 1
						},
						{
							id: 3,
							text: '2 ani',
							sumValue: 0,
							years: 2
						},
						{
							id: 4,
							text: '3 ani',
							sumValue: 0,
							years: 3
						},
						{
							id: 5,
							text: '4 ani',
							sumValue: 0,
							years: 4
						},
						{
							id: 6,
							text: '5 ani',
							sumValue: 0,
							years: 5
						},
						{
							id: 7,
							text: '6 ani',
							sumValue: 0,
							years: 6
						},
						{
							id: 8,
							text: '7 ani',
							sumValue: 0,
							years: 7
						},
						{
							id: 9,
							text: '8 ani',
							sumValue: 0,
							years: 8
						},
						{
							id: 10,
							text: '9 ani',
							sumValue: 0,
							years: 9
						},
						{
							id: 11,
							text: 'Peste 10 ani',
							sumValue: 0,
							years: 11
						}
					]
				},
				{
					id: 8,
					order: 8,
					text: 'Virsta persoanelor admise la conducere:',
					type: 'radio',
					optionsDirection: 'row',
					parent: 6,
					children: [],
					visibleIf: {
						questionId: 6,
						answer: 1
					},
					options: [
						{
							id: 1,
							text: 'Pana la 23 ani',
							sumValue: 1.1
						},
						{
							id: 2,
							text: 'Peste 23 ani',
							sumValue: 0.9
						},
						{
							id: 3,
							text: 'Pensionar',
              sumValue: 0.75
						}
					]
				},
				{
					id: 10,
					order: 9,
					isBonus: true,
					text: 'Ati mai incheiat contract de asigurare RCA?',
					type: 'radio',
					optionsDirection: 'row',
					parent: 2,
					visibleIf: {
						questionId: 1,
						answer: 1
					},
					children: [12, 11],
					options: [
						{
							id: 1,
							text: 'Nu'
						},
						{
							id: 2,
							text: 'Da'
						}
					]
				},
				{
					id: 11,
					order: 10,
					isBonus: true,
					text: 'De cate accidente va faceti vinovat incepand cu anul 2013?',
					type: 'radio',
					optionsDirection: 'row',
					parent: 10,
					children: [],
					visibleIf: {
						questionId: 10,
						answer: 2
					},
					options: [
						{
							id: 1,
							text: 'Nici unul',
							bonusValue: 0
						},
						{
							id: 2,
							text: '1',
							bonusValue: -3
						},
						{
							id: 3,
							text: '2',
							bonusValue: -5
						},
						{
							id: 4,
							text: '3',
							bonusValue: -7
						},
						{
							id: 5,
							text: 'mai mult',
							bonusValue: -17
						}
					]
				},
				{
					id: 12,
					order: 11,
					isBonus: true,
					text: 'Selectati anii in care ati avut asigurare RCA:',
					type: 'multiple',
					optionsDirection: 'row',
					parent: 10,
					children: [],
					visibleIf: {
						questionId: 10,
						answer: 2
					},
					options: (() => {
						const year = new Date().getFullYear();
            const initYear = 2013;
						const yearsToToday = Array.from({ length: year - initYear }, (value, index) => year - index);
						yearsToToday.reverse();
						return yearsToToday.map(el => {
							return {
								id: el,
								text: el,
								bonusValue: 1
							};
						});
					})()
				}
			]
		},
		vehicle: {
			value: 2,
			title: 'Autovehicol',
			questions: [
				{
					id: 1,
					order: 1,
					text: 'Ati mai asigurat acest autovehicol la noi?',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [2, 3],
					options: [
						{
							id: 1,
							text: 'Da'
						},
						{
							id: 2,
							text: 'Nu'
						}
					]
				},
				{
					id: 2,
					order: 2,
					text: 'Alege tipul certificatului de inmatriculare:',
					type: 'radio',
					optionsDirection: 'row',
					parent: 1,
					children: [],
					visibleIf: {
						questionId: 1,
						answer: 2
					},
					options: [
						{
							id: 1,
							text: 'Vechi',
							value: 'old',
							imageName: 'https://www.bancassurance.md/public/assets/img/cert-old.jpg'
						},
						{
							id: 2,
							text: 'Nou',
							value: 'new',
							imageName: 'https://www.bancassurance.md/public/assets/img/cert-new.jpg'
						},
						{
							id: 3,
							text: 'Provizoriu',
							value: 'temp',
							imageName: 'https://www.bancassurance.md/public/assets/img/cert-temp.jpg'
						}
					]
				},
				{
					id: 3,
					order: 2,
					text: 'Introdu doar numarul de inmatriculare:',
					type: 'text',
					parent: 1,
					children: [],
					innerIcon: 'mdi-car-outline',
					placeholder: 'AAA111',
					rules: [
						formRules.required
						// formRules.validCarPlate
					],
					visibleIf: {
						questionId: 1,
						answer: 1
					}
				}
			]
		},
		driver: {
			value: 3,
			title: 'Conducatorii',
			questions: []
		},
		confirm: {
			value: 4,
			title: 'Confirma',
			questions: []
		}
	},
	greenCard: {
		calculator: {
			value: 1,
			title: 'Calculeaza',
			questions: [
				{
					id: 1,
					order: 1,
					text: 'Zona de deplasare:',
					type: 'radio',
					optionsDirection: 'column',
					parent: null,
					children: [3, 4],
					options: [
						{
							id: 1,
							text: 'Ucraina, Belarus',
							value: 0
						},
						{
							id: 2,
							text: 'Ucraina, Belarus, Federaţia Rusă',
							value: 0
						},
						{
							id: 3,
							text: 'Ţările din sistemul „CarteVerde” (Europa)',
							value: 0
						}
					]
				},
				{
					id: 2,
					order: 2,
					text: 'Valabilitatea poliţei:',
					type: 'dropdown',
					parent: null,
					children: [],
					options: DURATIONS_LIST
				},
				{
					id: 3,
					order: 3,
					text: 'Tipul autovehicolului:',
					type: 'dropdown',
					parent: 1,
					children: [5, 6],
					filterable: true,
					options: [
						{
							id: 1,
							text: 'Autoturism (< 9 locuri incl. conducatorul)',
							roadTaxValue: 1
						},
						{
							id: 2,
							text: 'Camion pana la 3,5 t',
							roadTaxValue: 2
						},
						{
							id: 3,
							text: 'Camion peste 3,5 t'
						},
						{
							id: 4,
							text: 'Transport de persoane (< 17 locuri)',
							roadTaxValue: 7
						},
						{
							id: 5,
							text: 'Transport de persoane (> 17 locuri)'
						},
						{
							id: 6,
							text: 'Motocicleta'
						}
					]
				},
				{
					id: 4,
					order: 4,
					text: 'Doriți să adăugați rovinieta?',
					type: 'radio',
					optionsDirection: 'row',
					parent: 1,
					visibleIf: {
						questionId: 1,
						answer: 3
					},
					children: [],
					options: [
						{
							id: 1,
							text: 'Da',
							value: 0
						},
						{
							id: 2,
							text: 'Nu',
							value: 0
						}
					]
				},
				{
					id: 5,
					order: 5,
					text: 'Masa maxima autorizata:',
					type: 'dropdown',
					parent: 3,
					children: [],
					visibleIf: {
						questionId: 4,
						answer: 1
					},
					filterable: true,
					filterableText: [
						{
							parentId: 3,
							text: 'Selectati greutatea:'
						},
						{
							parentId: 5,
							text: 'Selectati numarul de locuri:'
						}
					],
					options: [
						{
							id: 1,
							parentId: 3,
							text: 'Transport marfă 3.5 t <= MTMA <= 7.5 t',
							roadTaxValue: 3
						},
						{
							id: 2,
							parentId: 3,
							text: 'Transport marfă 7.5 t <= MTMA <= 12.0 t',
							roadTaxValue: 4
						},
						{
							id: 3,
							parentId: 3,
							text: 'Transport marfă MTMA >= 12 tone cu maxim 3 axe',
							roadTaxValue: 5
						},
						{
							id: 4,
							parentId: 3,
							text: 'Transport marfă MTMA >= 12 tone cu minim 4 axe',
							roadTaxValue: 6
						},
						{
							id: 5,
							parentId: 5,
							text: 'Transp. pers. 9-23 locuri, inclusiv conducătorul',
							roadTaxValue: 7
						},
						{
							id: 6,
							parentId: 5,
							text: 'Transport persoane peste 23 locuri',
							roadTaxValue: 8
						}
					]
				},
				{
					id: 6,
					order: 6,
					text: 'Indicați perioada valabilității rovinietei:',
					type: 'radio',
					optionsDirection: 'column',
					parent: 3,
					visibleIf: {
						questionId: 4,
						answer: 1
					},
					children: [],
					options: [
						{
							id: 1,
							text: '1 zi',
							baseText: '1 zi',
							roadTaxValue: 1
						},
						{
							id: 2,
							text: '7 zile',
							baseText: '7 zile',
							roadTaxValue: 2
						},
						{
							id: 3,
							text: '30 zile',
							baseText: '30 zile',
							roadTaxValue: 3
						},
						{
							id: 4,
							text: '90 zile',
							baseText: '90 zile',
							roadTaxValue: 4
						},
						{
							id: 5,
							text: '12 luni',
							baseText: '12 luni',
							roadTaxValue: 5
						}
					]
				}
			]
		},
		vehicle: {
			value: 2,
			title: 'Autovehicol',
			questions: [
				{
					id: 1,
					order: 1,
					text: 'Ati mai asigurat acest autovehicol la noi?',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [2, 3],
					options: [
						{
							id: 1,
							text: 'Da'
						},
						{
							id: 2,
							text: 'Nu'
						}
					]
				},
				{
					id: 2,
					order: 2,
					text: 'Alege tipul certificatului de inmatriculare:',
					type: 'radio',
					optionsDirection: 'row',
					parent: 1,
					children: [],
					visibleIf: {
						questionId: 1,
						answer: 2
					},
					options: [
						{
							id: 1,
							text: 'Vechi',
							value: 'old',
							imageName: 'https://www.bancassurance.md/public/assets/img/cert-old.jpg'
						},
						{
							id: 2,
							text: 'Nou',
							value: 'new',
							imageName: 'https://www.bancassurance.md/public/assets/img/cert-new.jpg'
						}
					]
				},
				{
					id: 3,
					order: 2,
					text: 'Introdu doar numarul de inmatriculare:',
					type: 'text',
					parent: 1,
					children: [],
					innerIcon: 'mdi-car-outline',
					placeholder: 'AAA111',
					rules: [
						formRules.required
						// formRules.validCarPlate
					],
					visibleIf: {
						questionId: 1,
						answer: 1
					}
				}
			]
		},
		driver: {
			value: 3,
			title: 'Asiguratul',
			questions: []
		},
		confirm: {
			value: 4,
			title: 'Confirma',
			questions: []
		}
	},
	casco: {
		calculator: {
			value: 1,
			title: 'Calculeaza',
			questions: [
				{
					id: 1,
					order: 1,
					text: 'Tipul autovehicolului:',
					type: 'dropdown',
					parent: null,
					children: [],
					options: [
						{
							id: 1,
							text: 'Autoturism'
						},
						{
							id: 2,
							text: 'Camion până la 3,5 tone'
						},
						{
							id: 3,
							text: 'Camion peste 3,5 tone'
						},
						{
							id: 4,
							text: 'Autobuz până la 20 locuri'
						},
						{
							id: 5,
							text: 'Autobuz peste 20 locuri'
						},
						{
							id: 6,
							text: 'Tehnică agricolă'
						}
					]
				},
				{
					id: 2,
					order: 2,
					type: 'multiple-questions',
					parent: null,
					children: [],
					items: [
						{
							id: 3,
							text: 'Marca:',
							type: 'text',
							parent: null,
							multipleParentId: 2,
							tooltip: 'Folosindu-te de indicii, indică marca și modelul autovehiculului. Dacă nu sunt în listă, le poți adăuga.',
							children: []
						},
						{
							id: 4,
							text: 'Model:',
							type: 'text',
							parent: null,
							multipleParentId: 2,
							children: []
						}
					]
				},
				{
					id: 5,
					order: 4,
					text: 'Anul producerii:',
					type: 'dropdown',
					children: [],
					options: (() => {
						const year = new Date().getFullYear();
						const yearsToToday = Array.from({ length: year - (year - 10) }, (value, index) => year - index);
						yearsToToday.reverse();
						return yearsToToday.map(el => {
							return {
								id: el,
								text: el
							};
						});
					})()
				},
				{
					id: 6,
					order: 5,
					text: 'Valoarea de piață:',
					type: 'text',
					innerIcon: 'mdi-currency-eur',
					parent: null,
					onlyNumbers: true,
					children: []
				},
				{
					id: 7,
					order: 6,
					text: 'Posesorul autovehicolului este persoana:',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [],
					options: [
						{
							id: 1,
							text: 'Fizica'
						},
						{
							id: 2,
							text: 'Juridica'
						}
					]
				},
				{
					id: 8,
					order: 7,
					text: 'Virsta persoanelor admise la conducere:',
					type: 'slider',
					parent: null,
					minValue: 18,
					maxValue: 70,
					children: [],
					options: []
				},
				{
					id: 9,
					order: 8,
					text: 'Stagiul persoanelor admise la conducere:',
					type: 'slider',
					minValue: 0,
					maxValue: 52,
					parent: 8,
					children: [],
					options: []
				},
				{
					id: 10,
					order: 9,
					text: 'Autovehiculul este în garanție la dealer-ul oficial:',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [],
					options: [
						{
							id: 1,
							text: 'Da'
						},
						{
							id: 2,
							text: 'Nu'
						}
					]
				},
				{
					id: 11,
					order: 10,
					text: 'Plata primei de asigurare:',
					type: 'radio',
					optionsDirection: 'row',
					parent: null,
					children: [],
					options: [
						{
							id: 1,
							text: 'Integral'
						},
						{
							id: 2,
							text: 'În rate'
						}
					]
				}
			]
		},
		vehicle: {
			value: 2,
			title: 'Autovehicol',
			questions: []
		},
		driver: {
			value: 3,
			title: 'Conducatorii',
			questions: []
		},
		confirm: {
			value: 4,
			title: 'Confirma',
			questions: []
		}
	},
	medical: {
		calculator: {
			value: 1,
			title: 'Calculeaza',
			questions: []
		},
		vehicle: {
			value: 2,
			title: 'Autovehicol',
			questions: []
		},
		driver: {
			value: 3,
			title: 'Conducatorii',
			questions: []
		},
		confirm: {
			value: 4,
			title: 'Confirma',
			questions: []
		}
	}
};

export const getQuestions = (section, step) => {
	return sections[section][step].questions;
};

export const getSectionSteps = (section) => {
	return Object.entries(sections[section]).map((el) => {
		const section = JSON.parse(JSON.stringify(el[1]));
		delete section.questions;
		return section;
	});
};

export const propertyRights = [
	{
		value: 'proprietate',
		text: 'Proprietate'
	},
	{
		value: 'locatiune',
		text: 'Locatiune'
	},
	{
		value: 'leasing',
		text: 'Leasing'
	},
	{
		value: 'procura-si-altele',
		text: 'Procura si alte titluri'
	}
];

export const cityDistricts = [
	{
		value: 'aeroport',
		text: 'Aeroport'
	},
	{
		value: 'botanica',
		text: 'Botanica'
	},
	{
		value: 'buiucani',
		text: 'Buiucani'
	},
	{
		value: 'centru',
		text: 'Centru'
	},
	{
		value: 'ciocana',
		text: 'Ciocana'
	},
	{
		value: 'durlesti',
		text: 'Durlesti'
	},
	{
		value: 'posta-veche',
		text: 'Posta Veche'
	},
	{
		value: 'riscani',
		text: 'Riscani'
	},
	{
		value: 'sculeni',
		text: 'Sculeni'
	},
	{
		value: 'telecentru',
		text: 'Telecentru'
	}
];

export const shippingOptions = [
	{
		value: 'self',
		text: 'Vin la oficiu'
	},
	{
		value: 'delivery',
		text: 'Doresc livrare'
	}
];

export const openingDays = [
	{
		dayIndex: 1,
		text: 'Luni',
		openingHour: '08',
		closingHour: '18'
	},
	{
		dayIndex: 2,
		text: 'Marti',
		openingHour: '08',
		closingHour: '18'
	},
	{
		dayIndex: 3,
		text: 'Miercuri',
		openingHour: '08',
		closingHour: '18'
	},
	{
		dayIndex: 4,
		text: 'Joi',
		openingHour: '08',
		closingHour: '18'
	},
	{
		dayIndex: 5,
		text: 'Vineri',
		openingHour: '08',
		closingHour: '18'
	},
	{
		dayIndex: 6,
		text: 'Sambata',
		openingHour: '09',
		closingHour: '14'
	},
	{
		dayIndex: 0,
		text: 'Duminica',
		closed: true
	}
];

export const vehicleQuestions = (questionId) => {
	const questions = [
		{
			id: 1,
			text: 'N° certificatului de inmatriculare:',
			placeholder: '000000000',
			rules: [
				formRules.required
				// formRules.validNumber,
				// formRules.validNewMatriculationNr
			]
		},
		{
			id: 2,
			text: 'N° de inmatriculare:',
			placeholder: 'AAA111',
			rules: [
				formRules.required
				// formRules.validCarPlate
			]
		},
		{
			id: 3,
			text: 'Marca:',
			rules: [
				formRules.required
			]
		},
		{
			id: 4,
			text: 'Model:',
			rules: [
				formRules.required
			]
		},
		{
			id: 5,
			text: 'N° caroseriei:',
			rules: [
				formRules.required
				// formRules.validBodyNr
			]
		},
		{
			id: 6,
			text: 'Anul fabricarii:',
			rules: [
				formRules.required,
				formRules.validNumber
				// formRules.validYear
			]
		},
		{
			id: 7,
			text: 'Tipul autovehicolului:',
			rules: [
				formRules.required
			]
		},
		{
			id: 8,
			text: 'Capacitatea cilindrica:',
			rules: [
				formRules.required,
				formRules.validNumber
			]
		},
		{
			id: 9,
			text: 'N° certificatului de inmatriculare:',
			placeholder: 'B000000000',
			rules: [
				formRules.required
				// formRules.validTempMatriculationNr
			]
		},
		{
			id: 10,
			text: 'Data expirarii politei RCA:',
			rules: []
		}
	];
	if (!questionId) {
		return questions;
	}
	return questions.filter(el => el.id === questionId);
};

export const driverQuestions = (questionId) => {
	const questions = [
		{
			id: 1,
			text: 'Codul fiscal (IDNO):',
			placeholder: '000000000000',
			rules: [
				formRules.required
				// formRules.validNumber,
				// formRules.validIdno
			]
		},
		{
			id: 2,
			text: 'Denumire companie:',
			rules: [
				formRules.required
			]
		},
		{
			id: 3,
			text: 'Dreptul de posesiune a autovehiculului:'
		},
		{
			id: 4,
			text: 'Codul personal (IDNP):',
			placeholder: '00000000000000',
			rules: [
				formRules.required
				// formRules.validNumber,
				// formRules.validIdnp
			]
		},
		{
			id: 5,
			text: 'Nume:',
			rules: [
				formRules.required
			]
		},
		{
			id: 6,
			text: 'Prenume:',
			rules: [
				formRules.required
			]
		}
	];
	if (!questionId) {
		return questions;
	}
	return questions.filter(el => el.id === questionId);
};

export const confirmationQuestions = (questionId) => {
	const questions = [
		{
			id: 1,
			text: 'Valabilitatea politei din data:'
		},
		{
			id: 2,
			text: 'Nume:',
			rules: [
				formRules.required
			]
		},
		{
			id: 3,
			text: 'Prenume:',
			rules: [
				formRules.required
			]
		},
		{
			id: 4,
			text: 'Codul personal (IDNP):',
			placeholder: '00000000000000',
			rules: [
				formRules.required
				// formRules.validNumber,
				// formRules.validIdnp
			]
		},
		{
			id: 5,
			text: 'Telefon:',
			rules: [
				formRules.required
				// formRules.validPhone
			]
		},
		{
			id: 6,
			text: 'E-mail:',
			rules: [
				formRules.required,
				formRules.validEmail
			]
		},
		{
			id: 7,
			text: 'Municipiul Chisinau:',
			rules: [
				formRules.required
			]
		},
		{
			id: 8,
			text: 'Adresa livrarii:',
			rules: [
				formRules.required
			]
		},
		{
			id: 9,
			text: 'Ziua livrarii:',
			rules: [
				formRules.required
			]
		},
		{
			id: 10,
			text: 'Observatii referitor la livrare:',
			rules: []
		},
		{
			id: 11,
			text: 'Carte verde din data:',
			rules: []
		},
		{
			id: 12,
			text: 'Rovinieta din data:',
			rules: []
		}
	];
	if (!questionId) {
		return questions;
	}
	return questions.filter(el => el.id === questionId);
};

export const cascoConfirmationQuestions = (questionId) => {
	const questions = [
		{
			id: 1,
			text: 'Nume:',
			rules: [
				formRules.required
			]
		},
		{
			id: 2,
			text: 'Telefon:',
			rules: [
				formRules.required
			]
		},
		{
			id: 3,
			text: 'E-mail:',
			rules: [
				formRules.required,
				formRules.validEmail
			]
		}
	];
	if (!questionId) {
		return questions;
	}
	return questions.filter(el => el.id === questionId);
};

// X-axis = duration (15 days to 12 months)
// Y-axis = vehicle type (A, C1, C2, E1, E2, B)
export const greenCardPrices = {
	zone1: [
		[3.15, 4.20, 6.30, 8.40, 10.50, 12.00, 14.70, 16.80, 17.85, 18.90, 21.00, 21.00, 21.00],
		[8.10, 10.80, 16.20, 21.60, 27.00, 32.40, 37.80, 43.20, 45.90, 48.60, 54.00, 54.00, 54.00],
		[13.50, 18.00, 27.00, 36.00, 45.00, 54.00, 63.00, 72.00, 76.50, 81.00, 90.00, 90.00, 90.00],
		[7.65, 10.20, 15.30, 20.40, 25.50, 30.60, 35.70, 40.80, 43.35, 45.90, 51.00, 51.00, 51.00],
		[13.50, 18.00, 27.00, 36.00, 45.00, 54.00, 63.00, 72.00, 76.50, 81.00, 90.00, 90.00, 90.00],
		[2.70, 3.60, 5.40, 7.20, 9.00, 10.80, 12.60, 14.40, 15.30, 16.20, 18.00, 18.00, 18.00]
	],
	zone2: [
		[23.20, 46.40, 69.60, 92.80, 116.00, 139.20, 162.40, 185.60, 197.20, 208.80, 232.00, 232.00, 232.00],
		[25.52, 51.04, 76.56, 102.08, 127.60, 153.12, 178.64, 204.16, 216.92, 229.68, 255.20, 255.20, 255.20],
		[23.20, 46.40, 69.60, 92.80, 116.00, 139.20, 162.40, 185.60, 197.20, 208.80, 232.00, 232.00, 232.00],
		[23.20, 46.40, 69.60, 92.80, 116.00, 139.20, 162.40, 185.60, 197.20, 208.80, 232.00, 232.00, 232.00],
		[20.88, 41.76, 62.64, 83.52, 104.40, 125.28, 146.16, 167.04, 177.48, 187.92, 208.80, 208.80, 208.80],
		[16.24, 32.48, 48.72, 64.96, 81.20, 97.44, 113.68, 129.92, 138.04, 146.16, 162.40, 162.40, 162.40]
	],
	zone3: [
		[35.91, 71.82, 107.73, 143.64, 179.55, 215.46, 251.37, 287.28, 305.24, 323.19, 359.10, 359.10, 359.10],
		[102.60, 205.20, 304.80, 410.40, 513.00, 615.60, 718.20, 820.80, 872.10, 923.40, 1026.00, 1026.00, 1026.00],
		[61.56, 123.12, 184.68, 246.24, 307.80, 369.36, 430.92, 492.48, 523.26, 554.04, 615.60, 615.60, 615.60],
		[153.90, 307.80, 461.70, 615.60, 769.50, 923.40, 1077.30, 1231.20, 1308.15, 1385.10, 1539.00, 1539.00, 1539.00],
		[71.82, 143.64, 215.46, 287.28, 359.10, 430.92, 502.74, 574.56, 610.47, 646.38, 718.20, 718.20, 718.20],
		[35.91, 71.82, 107.73, 143.64, 179.55, 215.46, 251.37, 287.28, 305.24, 323.19, 359.10, 359.10, 359.10]
	]
};

// EUR
export const roadTax = [
	[0, 3, 7, 13, 28],
	[0, 6, 16, 36, 96],
	[4, 16, 32, 92, 320],
	[7, 28, 56, 160, 560],
	[9, 36, 72, 206, 720],
	[11, 55, 121, 345, 1210],
	[4, 20, 52, 120, 320],
	[7, 35, 91, 210, 560]
];

export const bonusMalusMultipliers = {
  0: 2.5,
  1: 2.2,
  2: 1.9,
  3: 1.6,
  4: 1.45,
  5: 1.3,
  6: 1.15,
  7: 1,
  8: 0.95,
  9: 0.9,
  10: 0.85,
  11: 0.8,
  12: 0.75,
  13: 0.7,
  14: 0.65,
  15: 0.6,
  16: 0.55,
  17: 0.5
};

// STATIC MDL
// export const roadTax = [
// 	[0, 70.21, 163.87, 304.29, 655.44],
// 	[0, 141.26, 376.65, 847.44, 2259.90],
// 	[94.14, 376.65, 753.30, 2165.71, 7532.89],
// 	[164.77, 659.11, 1318.27, 3766.44, 13182.58],
// 	[211.88, 847.44, 1694.92, 4849.32, 16949.03],
// 	[258.95, 1294.71, 2848.38, 8121.42, 28483.80],
// 	[94.14, 470.79, 1224.09, 2824.82, 7532.89],
// 	[164.77, 823.93, 2142.15, 4943.46, 13182.58]
// ];
